var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThrottle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-300.71-460.14l-2.52-.77v-1.82l2.52,1.32Zm0,1.86h-2.52v-1.86l2.52.78Zm0,14.81h-2.52v-14c.49,0,1.5,0,2.52,0Zm0,1.82-2.52.81v-1.86h2.52Zm0,2.21-2.52,1.55V-440l2.52-.82ZM-304-461h-10.31V-463L-304-463Zm0,2.79c-1,0-4.5,0-7.73,0v-2H-304Zm0,14.73h-10.31v-14c3.56,0,5.92,0,7.54,0s2.32,0,2.77,0Zm0,2.79h-7.73v-2H-304Zm0,2.9h-10.31v-2.13H-304ZM-315-462.31h-11.1v-5.61l.56.65v4.11h.75l9.79.08Zm0,1.32h-11.1v-.54H-315Zm0,2.71h-18.23a1.78,1.78,0,0,1,.23.78v.89h18v3.95h-22.43v-1.16h2.89a.77.77,0,0,0,.78-.77v-3a.76.76,0,0,0-.78-.77h-2.89v-2h1.16v-1.28h9.38v1.32h11.86v2Zm0,8.38h-1.68a1.52,1.52,0,0,1-1.47,1.12,1.51,1.51,0,0,1-1.46-1.12h-.75a1.46,1.46,0,0,1-.75.93h0a.44.44,0,0,1-.19.07s-.07,0-.07,0-.11,0-.15,0-.15,0-.23,0h0a.75.75,0,0,1-.3,0h0a.53.53,0,0,1-.23-.08s0,0,0,0l-.23-.11a0,0,0,0,1,0,0,.73.73,0,0,1-.18-.16h0a1.51,1.51,0,0,1-.3-.46v0a.23.23,0,0,1,0-.15h-5.18a1.51,1.51,0,0,1-1.46,1.12,1.52,1.52,0,0,1-1.47-1.12h-6.11V-451h6.23a1.5,1.5,0,0,1,1.12-.85h0c.07,0,.11,0,.19,0a1.45,1.45,0,0,1,1.35.89h5.4a1.41,1.41,0,0,1,1.28-.85,1.37,1.37,0,0,1,1.27.85h1a1.55,1.55,0,0,1,1.35-.89h.07a.47.47,0,0,1,.23,0h0a1.29,1.29,0,0,1,.71.39,1.07,1.07,0,0,1,.34.46h1.8v1.13Zm0,2.71h-22.43v-1.09h22.4v1.09Zm0,2.63h-22.43v-1h22.4v1Zm0,4.73h-7.12v-1.78a1.77,1.77,0,0,1-.75,1v2.82h-1.39v-2.79a1.61,1.61,0,0,1-.75-.85h-.68a1.17,1.17,0,0,1,0,.39,1.49,1.49,0,0,1-1.46,1.51,1.47,1.47,0,0,1-1.47-1.51c0-.12,0-.27,0-.39h-.75a1.48,1.48,0,0,1-.75.85v2.79h-1.39v-2.82a1.52,1.52,0,0,1-.75-1v1.78h-5.25v-3.06H-332a1.85,1.85,0,0,1,.45-.43s.08,0,.12-.07.07,0,.07,0,.15,0,.23-.08h.37a1.43,1.43,0,0,1,1.2.62h4.65a.33.33,0,0,1,.15-.16l.08-.07s0,0,.07,0a1.49,1.49,0,0,1,1-.35,1.54,1.54,0,0,1,1.24.66H-315v3Zm0,2h-7.12v-1.28H-315Zm-17.18,0h-5.25V-439h5.25Zm-6-2H-339v-13.95h.75Zm0,2H-339V-439h.75Zm-1.5,0h-.53l0-3v-.77h-1.83v-1.17h-1.69v-16.35h1.69v-1.16h2.4v2h-.12a.77.77,0,0,0-.78.78v2.94a.77.77,0,0,0,.78.78h.12Zm5.14-19.69h0l0,2.91h0l-5.26,0h0v-2.91h0Zm-4.39-2.75h.75v2H-339Zm1.35-4.34v-2.64l.56-.69v3.33Zm1.31-3.72h9.38v6h-9.38v-6Zm22,25.61h1.83v2h-1.83Zm0-17.51h1.83v2h-1.83Zm-30.28,22.36h-16.32V-473.7h11.81v22.75h.75v-13h3.76Zm-18.65-36.66v-2.71h16.47v2.71Zm1.31,29.84h-5.21v-12.6h5.21Zm-6,2h-3.38v-16.66h3.38Zm64.34-21.08-21.35-.15v-3.65l-1.27-1.55h-10.92l-1.31,1.55v3.68h1.31v2.79h-5.81v1.17h-.94v-4.85h-4.51v-9H-346V-478h-18v4.26h2.36V-458h-5.51v-2H-372v18.22h4.88v-2.06h5.48v6.82h17.82V-442h.94v1.16H-341l0,3.76,37,0h.75l3.26-2v-22.94Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -329.5,
    cy: -450.5,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -330.5,
    cy: -442.5,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -323.5,
    cy: -442.5,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -321.5,
    cy: -450.5,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -318.5,
    cy: -450.5,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -327.5,
    cy: -440.5,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-314.3-455.51h-18.76v.73a1,1,0,0,1-.24.64h19Z",
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Graphic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77,27l-6-6v5H65V14.6l-11,11-11-11V26H37a15,15,0,0,0-29.9,0H0v2H7.05A15,15,0,0,0,21,42V55H39V65h2V53H23V42A15,15,0,0,0,37,28h6V39.42l11-11,11,11V28h6v5ZM34.89,25.42,17.17,15A13,13,0,0,1,34.89,25.42ZM9,27a13,13,0,0,1,6.07-11L33.65,27,15.07,38A13,13,0,0,1,9,27ZM22,40a13,13,0,0,1-4.83-.94L34.89,28.6A13,13,0,0,1,22,40ZM45,34.6V19.42L52.59,27Zm18,0L55.41,27,63,19.42Z",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrottle);
export default __webpack_public_path__ + "static/media/Throttle.27bedd25192ac27ec185a86d3f722b94.svg";
export { ForwardRef as ReactComponent };